/** Возвращает строковый UUID — для client_id операции (идемпотентный ключ). */
export function newClientId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Фоллбэк (старые браузеры): timestamp + случайная часть.
  return `cli_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}
